// core
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// campfire
import { PartnerBrandService, IntercomService, AnalyticsService } from '@campfire-nx/api';

import { environment } from '@open-portal-env';
import { AuthService } from '@open-portal-app/core/services/auth.service';
import { RAPTOR_SUPPORT_FLOW_TOPICS } from '@open-portal-app/help/constants/help.constants';
import { COMMON_CONSTANTS } from '@open-portal-app/core/constants/common.constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  raptorFlows = COMMON_CONSTANTS.raptorFlows;
  pagesWithoutSupportLinks = ['supportFlow', 'appointmentFlow'];
  supportPhoneNumber?: string;
  supportPhoneLabel?: string;
  uuid?: string;
  pageType!: string;
  isLandingPage!: boolean;
  isRaptorFlow!: boolean;
  isAhmLandingPage!: boolean;
  isSupportLinkHidden!: boolean;
  linkToHelpFlow?: boolean;
  logo?: string;
  apiEndpoint?: string;
  intercom?: any;
  partnerName?: string;
  isEndorsementEnabled?: boolean;
  unreadCount = 0;
  isLoggedIn!: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public partnerBrandService: PartnerBrandService,
    private intercomService: IntercomService,
    private analyticsService: AnalyticsService,
    private changeDetectorRef: ChangeDetectorRef,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.pageType = data.pageType || 'default';
    });

    this.isLoggedIn = this.authService.isAuthenticated();

    if (this.router.url.indexOf('/payment/update/') > -1) {
      this.pageType = 'updatePaymentFlow';
    } else if (this.router.url.indexOf('/payment/retry/') > -1) {
      this.pageType = 'retryPaymentFlow';
    }

    this.apiEndpoint = environment.apiEndpoint;
    this.isLandingPage = this.pageType === 'landingPage';
    this.isAhmLandingPage = this.isLandingPage && this.partnerBrandService.getAttribute('slug', 'partner') === 'ahm';
    this.isRaptorFlow = this.pageType && this.raptorFlows.indexOf(this.pageType) !== -1 || false;
    this.isSupportLinkHidden = this.pageType &&
      this.pagesWithoutSupportLinks.indexOf(this.pageType) !== -1 || false;
    this.isEndorsementEnabled = this.partnerBrandService.getAttribute('product', 'partner')?.is_self_serviced_endorsement_enabled;

    const url = this.router.url;
    const splitUrl = url.split('/').pop();

    if (splitUrl) {
      this.uuid = splitUrl.split('?').shift();
    }
  }

  ngAfterViewChecked():void {
    this.intercom = this.partnerBrandService.getAttribute('intercom', 'partner');
    this.partnerName = this.partnerBrandService.getAttribute('name', 'partner');

    this.setNewMessageCallback();
    this.changeDetectorRef.detectChanges();
  }

  showOpenLogo(positive: boolean) {
    if (positive) {
      return !this.partnerBrandService.data.partner.slug || this.partnerBrandService.data.partner.slug === 'open' || !this.apiEndpoint && !this.partnerBrandService.data.brand.brand?.logoLarge
    } else {
      return this.partnerBrandService.data.partner.slug !== 'open' && this.apiEndpoint && this.partnerBrandService.data.partner.brand?.logoLarge
    }
  }

  public startSupport () {
    if (this.intercom?.intercomAppId) {
      this.showIntercom();
    } else {
      this.startSupportFlow();
    }
  }

  public showIntercom() {
    this.analyticsService.trackEvent(
      'chat-with-us',
      'general',
      'intercom',
      {}
    );
    this.intercomService.show();
  }

  public startSupportFlow() {
    const isRaptorFlow = this.raptorFlows.indexOf(this.pageType) !== -1 || false;
    let params = {};

    if (this.intercom && !this.isEndorsementEnabled) {
      this.showIntercom();
      return;
    }

    if (isRaptorFlow) {
      params = {
        subject: RAPTOR_SUPPORT_FLOW_TOPICS[this.pageType].subject,
        'customer-intent': RAPTOR_SUPPORT_FLOW_TOPICS[this.pageType]['customer-intent'],
        'reference-list': this.uuid,
        ...(this.isRaptorFlow ? { flow: this.pageType } : {}),
      };
    }

    this.analyticsService.trackEvent(
      'get-support',
      'general',
      'helpflow',
      params
    );
    this.router.navigate(
      ['/support'],
      { queryParams: Object.keys(params).length ? params : {} }
    );
  }

  public getReturnURL() {
    if (this.partnerBrandService.data.partner.redirectBack) {
      return this.partnerBrandService.data.partner.redirectBack;
    }

    return '';
  }

  public setNewMessageCallback() {
    this.intercomService.setOnUnreadCountChange((unreadCount: number) => {
      this.unreadCount = unreadCount;
    });
  }
}
